var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EMCoreTemplate',{attrs:{"category":"Core","identity":"contact","entity":"crm_contact"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8738df","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Adm/EntityManagementCore/containers/Contact.vue
// module id = null
// module chunks = 